import { footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-cinema-bg border-t border-cinema-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 group cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-cinema-gold text-2xl"></i>
              </div>
              <span className="font-heading text-lg text-white group-hover:text-cinema-gold transition-colors">黄瓜影院</span>
            </a>
            <p className="text-xs text-cinema-muted leading-relaxed mb-4">
              黄瓜影院影视搜索快速找片，智能推荐精准匹配，高清在线观看流畅不缓冲。免费电视剧全集、最新剧集、电影大全海量片库即点即播。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-cinema-card hover:bg-cinema-gold/20 text-cinema-muted hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-wechat-fill text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-cinema-card hover:bg-cinema-gold/20 text-cinema-muted hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-weibo-fill text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-cinema-card hover:bg-cinema-gold/20 text-cinema-muted hover:text-cinema-gold transition-colors cursor-pointer">
                <i className="ri-bilibili-fill text-sm"></i>
              </div>
            </div>
          </div>

          {footerLinks.columns.map((col, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-white mb-4">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      className="text-xs text-cinema-muted hover:text-cinema-gold transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-cinema-border pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-xs text-cinema-muted">
              &copy; 2026 黄瓜影院 huanggua.tv 版权所有 | 本站内容仅供学习交流
            </div>
            <div className="flex items-center gap-4 text-xs text-cinema-muted">
              <span>合作伙伴</span>
              <span className="text-cinema-border">|</span>
              <span>即将上线</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}